import { render } from "./LeaveRecordModal.vue?vue&type=template&id=796830dc&scoped=true"
import script from "./LeaveRecordModal.vue?vue&type=script&lang=js"
export * from "./LeaveRecordModal.vue?vue&type=script&lang=js"

import "./LeaveRecordModal.vue?vue&type=style&index=0&id=796830dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796830dc"]])

export default __exports__